<app-subskrypcje-filtry [showSubsWithEvents]="showSubsWithEvents"></app-subskrypcje-filtry>
<app-subskrypcje-tabela></app-subskrypcje-tabela>
<app-dane-podmiotu [hideAdd]="hideAdd"></app-dane-podmiotu>
